import { Link } from 'react-router-dom'
import { PlayLogo } from '@/components/brand/PlayLogo'
import { AccountMenu } from '@/components/account/AccountMenu'
import './workspace.css'

/** The event workspace's quiet header, the same on each of its pages: the logo back to the events, an optional label
 *  such as Host workspace, and the account menu. */
export function WorkspaceHeader({ label }: { label?: string }) {
  return (
    <header className="pw-header">
      <Link to="/app" aria-label="Your events">
        <PlayLogo />
      </Link>
      <div className="pw-header-right">
        {label && <span className="pw-host-label">{label}</span>}
        <AccountMenu />
      </div>
    </header>
  )
}
